module.exports = __webpack_public_path__ + "static/media/bookly1.eb723d43.png";